import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getCount = (state: RootState) => state.pages.editor.canvas.latestRequestCount;

const getLatestRequestCount = createSelector([getCount], (count) => count);

export default getLatestRequestCount;
